import { stringifyUrl, TapiEndpointFactory } from '../baseQuery';

export const getCampaignMatchesStatsEndpoint: TapiEndpointFactory<'V1CampaignsMatchesStatsDetail'> =
  (builder) =>
    builder.query({
      query: ({ id, query }) =>
        stringifyUrl(`/campaigns/${id}/matches_stats`, query),
      keepUnusedDataFor: 15,
    });
